import { render } from "./event-badge-generator.vue?vue&type=template&id=53cc204e"
import script from "./event-badge-generator.vue?vue&type=script&lang=js"
export * from "./event-badge-generator.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__